import { h } from 'preact';
import { Text } from 'preact-i18n';

// Shown on /convention/:id when the convention load comes back empty.
//
// get-convention.js requires `offline < 1` AND the domain's customer scope AND
// (you are on `members` OR the convention is `public`), and returns an empty result
// set for every failure — so a deleted stevne and one you simply cannot see are
// indistinguishable from the webapp. The wording therefore stays neutral, and a
// logged-out visitor is offered a login because logging in may actually reveal it.
const ConventionNotFound = ({ stores }) => {
    const { userStore } = stores;
    const { user = {} } = userStore;
    const isLoggedIn = !!user.id;

    return (
        <div class='w-100 text-center py-5 px-3'>
            <div class='display-1 text-body-secondary'>
                <i class='fa-duotone fa-calendar-xmark' />
            </div>
            <h5 class='mt-3'>
                <Text id='convention.not-found'>The convention could not be found</Text>
            </h5>
            <p class='text-body-secondary'>
                <Text id='convention.not-found-help'>
                    It may have been deleted, or you may not have access to it.
                </Text>
            </p>
            <div class='d-flex flex-column align-items-center gap-2 mt-4'>
                <a class='btn btn-primary rounded-pill px-4' href='/convention'>
                    <i class='fa-solid fa-list me-2' />
                    <Text id='convention.not-found-all'>See all conventions</Text>
                </a>
                {!isLoggedIn && (
                    <a class='btn btn-outline-secondary rounded-pill px-4' href='/login'>
                        <i class='fa-solid fa-right-to-bracket me-2' />
                        <Text id='login.login'>Log in</Text>
                    </a>
                )}
            </div>
        </div>
    );
};

export default ConventionNotFound;
